export enum AarStorageLocationsType {
  Dafza = 1,
  Cage = 2,
  DafzaPriority = 3,
}

export const AarStorageLocations = [
  { Description: "DAFZA", Value: AarStorageLocationsType.Dafza },
  { Description: "CAGE", Value: AarStorageLocationsType.Cage },
  { Description: "DAFZA PRIORITY", Value: AarStorageLocationsType.DafzaPriority },
];
